// contexts/LoadingContext.tsx
import { useIdleLogout } from "../Context/useIdleLogout";
import {useEffect} from 'react';
import {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";

interface LoadingContextType {
  isLoading: boolean;
  showLoader: () => void;
  hideLoader: () => void;
  isSaudiMobile:(mobile:string) => boolean;
  isEmail:(mobile:string) => boolean;
  CurrentTime:()=>string;
}

const LoadingContext =
  createContext<LoadingContextType>(null!);

export const LoadingProvider = ({
  children,
}: {
  children: ReactNode;
}) => { 
  const [isLoading, setIsLoading] =
    useState(false);
  const [currentTime, setCurrentTime] = useState("");

  const showLoader = () => setIsLoading(true);
  const hideLoader = () => setIsLoading(false);
  const isSaudiMobile = (phone: string) => {
    return /^(?:05|9665|\+9665)\d{8}$/.test(phone);
  };
   const isEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
  
  const CurrentTime=()=>{
     const updateTime = () => {
      const now = new Date();

      setCurrentTime(
        now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    };
      const interval = setInterval(updateTime, 1000);
 return String(currentTime);
  }
 
  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        showLoader,
        hideLoader,
        isSaudiMobile,
        isEmail,
        CurrentTime
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () =>
  useContext(LoadingContext);


 